import { UtenteVO } from "./utenteVO";

export class CommentoVO {
    autore: UtenteVO;
    data: string;
    id: string;
    testo: string;
}